import React, { FC, useState } from 'react';
import { 
  IconButton, 
  Menu, 
  MenuItem, 
  ListItemIcon, 
  ListItemText,
  Tooltip
} from '@material-ui/core';
import { Language } from '@material-ui/icons';
import { SupportedLanguages, useI18n } from 'utils/i18n/hooks/useI18n';
import styles from './LanguageSelector.module.scss';

export interface ILanguageSelectorProps {
  className?: string;
}

const LanguageSelector: FC<ILanguageSelectorProps> = ({ className }) => {
  const { t, changeLanguage, getCurrentLanguage, getAvailableLanguages } = useI18n();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const availableLanguages = getAvailableLanguages();
  const currentLanguage = getCurrentLanguage();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (languageCode: SupportedLanguages) => {
    changeLanguage(languageCode);
    handleClose();
  };

  const getCurrentLanguageName = () => {
    const current = availableLanguages.find(lang => lang.code === currentLanguage);
    return current ? current.name : 'Português (Brasil)';
  };

  const getLanguageFlag = (code: string) => {
    const flags: { [key: string]: string } = {
      'pt-BR': '🇧🇷',
      'pt-PT': '🇵🇹',
      'en-US': '🇺🇸',
      'es-ES': '🇪🇸',
      'fr-FR': '🇫🇷'
    };
    return flags[code] || '🌐';
  };

  return (
    <>
      <Tooltip title={`Idioma atual: ${getCurrentLanguageName()}`}>
        <IconButton
          //className={`${styles.languageButton} ${className || ''}`}
          onClick={handleClick}
          aria-label="Selecionar idioma"
        >
          <span className={styles.flag} style={{ color: "#FFF", lineHeight: "21px" }}>{getLanguageFlag(currentLanguage)}</span>
        </IconButton>
      </Tooltip>
      
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={styles.menu}
        PaperProps={{
          className: styles.menuPaper
        }}
      >
        {availableLanguages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            selected={language.code === currentLanguage}
            className={styles.menuItem}
          >
            <ListItemIcon className={styles.flagIcon}>
              <span className={styles.flag}>{getLanguageFlag(language.code)}</span>
            </ListItemIcon>
            <ListItemText 
              primary={language.name}
              className={styles.languageText}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
